import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react'

// ソート指標（小さな矢印）。現在のソート対象なら向きを、それ以外は中立アイコンを出す（v0 には無かった要素）
export function SortIndicator({ active, order }: { active: boolean; order: 'asc' | 'desc' | undefined }) {
  if (!active) {
    return <ChevronsUpDown className="size-3.5 text-muted-foreground/50" />
  }
  return order === 'asc' ? (
    <ArrowUp className="size-3.5 text-primary" />
  ) : (
    <ArrowDown className="size-3.5 text-primary" />
  )
}
